module.exports = __webpack_public_path__ + "static/media/life.in.the.orchard-IG.47df4625.PNG";